<header class="header-auto header-contact">
    <div class="container-m">
      <div class="topline-wrapper b-30px c-center">
        <div class="text-topline">Let’s talk</div>
        <div class="topline-line bg-primary c-center"></div>
      </div>
      <div class="content-wrapper">
        <h1 class="h1 l-center">Have any questions? We’re happy to answer.</h1>
      </div>
    </div>
    <div class="bg-section bg-background"></div>
  </header>
  <section class="section standard t-0px">
    <div class="container-m">
      <div class="w-layout-grid grid _2er">
        <div id="w-node-_981230ac-b27c-7b9d-04e0-a31115ed8f92-15ed8f83" class="grid-item">
          <h3 class="h3">Other contacts</h3>
          <p class="text-small">Speak to someone at Hudson today.</p>
          <div class="icon-text-wrapper m-t-30px">
            <div class="icon-text-inner r-20px"><img src="../../assets/images/Gruppe-874.svg" loading="lazy" width="79" alt="" class="image wh-60px"></div>
            <div class="icon-text-inner">
              <h6 class="h5">General Mail</h6>
              <a href="mailto:info@hudsondubai.com?subject=Hey%20HUDSON" class="link-mail text-default">info&#64;hudsondubai.com</a>
            </div>
          </div>
          <div class="icon-text-wrapper">
            <div class="icon-text-inner r-20px"><img src="../../assets/images/Gruppe-875.svg" loading="lazy" width="79" alt="" class="image wh-60px"></div>
            <div class="icon-text-inner">
              <h6 class="h5">General number</h6>
              <a href="tel:+97145693115" class="link-mail text-default">+971 4 380 5710</a>
            </div>
          </div>
          <div class="icon-text-wrapper">
            <div class="icon-text-inner r-20px"><img src="../../assets/images/Gruppe-871.svg" loading="lazy" width="79" alt="" class="image wh-60px"></div>
            <div class="icon-text-inner">
              <h6 class="h5">Whatsapp</h6>
              <a href="https://wa.me/971521093760?text=Hi%20Hudson,%20I%20have%20an%20inquiry" class="link-mail text-default">Click here</a>
            </div>
          </div>
        </div>
        <div id="w-node-_981230ac-b27c-7b9d-04e0-a31115ed8faf-15ed8f83" class="grid-item">
          <div class="image-wrapper i-layers-left"><img src="../../assets/images/Gruppe-831.svg" loading="lazy" width="876" alt="" class="image i-layer-01 contact-image-01"><img src="../../assets/images/Aerial-view-01_Revised_EDIT.jpg" loading="lazy" width="876" sizes="(max-width: 767px) 100vw, 480px" alt="" srcset="../../assets/images/Aerial-view-01_Revised_EDIT-p-500.jpeg 500w, ../../assets/images/Aerial-view-01_Revised_EDIT-p-800.jpeg 800w, ../../assets/images/Aerial-view-01_Revised_EDIT.jpg 993w" class="image i-layer-02 contact-image-02"></div>
        </div>
      </div>
    </div>
    <div class="bg-section bg-background"></div>
  </section>
  <section class="section standard t-0px">
    <div class="container-m">
      <div class="w-layout-grid grid _2er">
        <div id="w-node-_981230ac-b27c-7b9d-04e0-a31115ed8fb7-15ed8f83" class="grid-item">
          <div class="form-box bg-light">
            <div class="content-wrapper i-80px">
              <h1 class="h4">Contact Sales</h1>
            </div>
            <div id="wf-form-contact" class="form-block-normal t-30px w-form">
              <div class="html-embed w-embed">
                <style>
.w-select {
  -webkit-appearance: none;
  -moz-appearance: none;
  border-radius: 0px;
  box-shadow: none !important;
}
</style>
              </div>
              <div data-w-id="8d2947b4-3379-efad-6f95-ba38bab4f427"  class="form-box bg-light">
                <div class="content-wrapper i-80px">
                  <h4 class="h4">Contact Sales</h4>
                </div>
                <div class="form-block-normal t-30px w-form">
                  <div class="html-embed w-embed">
                  </div>
                  <!-- <form method="post" data-name="Contact" id="wf-form-Contact" name="wf-form-Contact" class="form" data-wf-page-id="615ea8ddc2e6612f62a9927d" data-wf-element-id="8d2947b4-3379-efad-6f95-ba38bab4f42d"> -->
                    <div class="w-layout-grid grid _2er-form-demo">
                      <div id="w-node-_8d2947b4-3379-efad-6f95-ba38bab4f42f-62a9927d" class="grid-item"><input class="input w-input" maxlength="256" name="First-Name" data-name="First Name" placeholder="First name" type="text" id="First_name" required [(ngModel)]="inquiryData.customerDetails.firstName"></div>
                      <div id="w-node-_8d2947b4-3379-efad-6f95-ba38bab4f431-62a9927d" class="grid-item"><input class="input w-input" maxlength="256" name="Last-Name-2" data-name="Last Name 2" placeholder="Last Name" type="text" id="Last-Name-2" [(ngModel)]="inquiryData.customerDetails.lastName"></div>
                      <div id="w-node-_8d2947b4-3379-efad-6f95-ba38bab4f433-62a9927d" class="grid-item"><input class="input w-input" maxlength="256" name="Email-2" data-name="Email 2" placeholder="Email" type="email" id="Email-2" [(ngModel)]="inquiryData.customerDetails.email"></div>
                      <div id="w-node-_8d2947b4-3379-efad-6f95-ba38bab4f435-62a9927d" class="grid-item"><input class="input w-input" maxlength="256" name="Phone-2" data-name="Phone 2" placeholder="Phone" type="tel" id="Phone-2" [(ngModel)]="inquiryData.customerDetails.phoneNo"></div>
                      <div id="w-node-_8d2947b4-3379-efad-6f95-ba38bab4f437-62a9927d" class="grid-item"><textarea placeholder="Message" maxlength="5000" id="field-2" name="field-2" data-name="Field 2" class="text-area w-input" [(ngModel)]="inquiryData.propertyDetails.inquiryDetail"></textarea></div>
                      <div id="w-node-_8d2947b4-3379-efad-6f95-ba38bab4f439-62a9927d" class="grid-item"><label class="w-checkbox checkbox-label t-10px"><input type="checkbox" id="checkbox-2" name="checkbox-2" data-name="Checkbox 2" [(ngModel)]="isAgreeTermServiceCheck" class="w-checkbox-input checkbox-hudson"><span class="text-xsmall text-default w-form-label" for="checkbox-2">I agree to the Terms of Service and Privacy Policy</span></label></div>
                      <div id="w-node-_8d2947b4-3379-efad-6f95-ba38bab4f43e-62a9927d" class="grid-item">
                        <button [ngClass]="{'btn-disable':!isContactFormValid()}" (click)="savePropertyInquiry()" class="button button-primary button-full-width button-form w-button">Connect with us</button>
                      </div>
                    </div>
                  <!-- </form> -->
                  <div class="form__success" *ngIf="isContactSubmitted">
                    <div class="h3">Thank you!</div>
                    <p class="text-big">We have received your request and will process it as soon as possible.</p>
                  </div>
                  <div class="form__error w-form-fail">
                    <div class="form__error-bg"></div>
                    <div class="form__error-text">Oops! Something went wrong while submitting the form.</div>
                  </div>
                </div>
              </div>
              <div class="form__success w-form-done">
                <div class="h3">Thank you!</div>
                <p class="text-big">We have received your request and will process it as soon as possible.</p>
              </div>
              <div class="form__error w-form-fail">
                <div class="form__error-bg"></div>
                <div class="form__error-text">Oops! Something went wrong while submitting the form.</div>
              </div>
            </div>
          </div>
        </div>
        <div id="w-node-_981230ac-b27c-7b9d-04e0-a31115ed8fd9-15ed8f83" class="grid-item">
          <div class="customer-content-box line-split">
            <div class="box-inner-flex">
              <h2 class="h3">Where you can find us?<br></h2>
              <p class="text-normal">Hudson Real Estate,<br>2103, The Exchange Tower,<br>Al Mustaqbal Street, Business Bay,<br>P.O Box – 117571,<br>Dubai, UAE<br></p>
              <div class="icon-text-wrapper i-google">
                <div class="icon-text-inner r-20px"><img src="../../assets/images/Gruppe-876.svg" loading="lazy" width="79" alt="" class="image wh-60px"></div>
                <div class="icon-text-inner">
                  <h6 class="h5">Google Maps</h6>
                  <a href="#" class="link-mail text-default">Click here</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bg-section bg-background"></div>
  </section>
  <section class="section standard t-20px section-box">
    <div data-w-id="ca13da15-9f73-5f9d-ef11-897b462276d0" class="container-box bg-dark">
      <div class="container-m">
        <div class="content-wrapper max-80p l-center">
          <h4 data-w-id="ca13da15-9f73-5f9d-ef11-897b462276d3" class="h2 l-center">Get in <span class="text-span">Touch</span></h4>
          <div class="content-wrapper max-80p l-center">
            <p data-w-id="39b339fb-9475-0589-4802-a037d65bbffd" class="text-normal l-center text-background">Contact our real estate experts to discuss your needs. Our team has the expertise to guide you through the entire process.<br></p>
          </div>
          <div data-w-id="bf7d05b6-ff9e-5077-5aa2-00ecb948f821" class="button-wrapper l-center t-30px">
            <a [routerLink]="['/buy-properties']" class="button button-primary r-25px w-button">Property to buy</a>
            <div class="button-wrapper-inner xs-t-20px">
              <a href="tel:+97145693115" class="button button-link button-line w-button">+971 4 380 5710</a>
            </div>
          </div>
        </div>
      </div><img src="../../assets/images/Gruppe-maskieren-78.svg" loading="lazy" alt="" class="image full-screen">
    </div>
    <div class="bg-section bg-background"></div>
  </section>